import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useIntlTranslations } from '@libs/intl/intl.hooks';

type QrPaymentRowProps = {
  label: string;
  amount?: string | null;
  isPaid: boolean;
  isPending: boolean;
  isMutating: boolean;
  disabled: boolean;
  onClick: () => void;
};

const QrPaymentRow = ({
  label,
  amount,
  isPaid,
  isPending,
  isMutating,
  disabled,
  onClick,
}: QrPaymentRowProps) => {
  const { t } = useIntlTranslations('QrPaymentRow');
  const statusText = isPaid ? 'ZAPLACENO' : isPending ? 'ČEKÁ NA ZAPLACENÍ' : 'PŘIPRAVENO K PLATBĚ';

  return (
    <Card
      variant="outlined"
      sx={{
        width: '100%',
        borderRadius: '4px',
        borderColor: 'divider',
        boxShadow:
          '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);',
      }}
    >
      <CardContent sx={{ padding: '8px', paddingBottom: '8px !important' }}>
        <Stack direction="row" alignItems="center" spacing={{ xs: 1, sm: 2 }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Stack direction="row" spacing={0.75} alignItems="center" sx={{ minWidth: 0 }}>
              <Typography variant="h6" color="text.primary" fontSize="14px">
                {label}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 0.35 }}>
              {isPaid && <CheckCircleIcon sx={{ fontSize: '1rem', color: 'success.main' }} />}
              <Typography variant="caption" color="text.secondary" fontSize="12px">
                {statusText}
              </Typography>
            </Stack>
          </Box>

          <Box
            sx={{
              alignSelf: 'stretch',
              width: '1px',
              bgcolor: 'divider',
              display: { xs: 'none', sm: 'block' },
            }}
          />

          <Typography
            variant="h6"
            sx={{
              minWidth: { xs: '3.5rem', sm: '5.5rem' },
              textAlign: 'right',
              fontWeight: 700,
              fontSize: { xs: '0.8rem', sm: '1.1rem' },
              whiteSpace: 'nowrap',
            }}
          >
            {amount}
          </Typography>

          <Button
            onClick={onClick}
            disabled={disabled || isMutating}
            variant="outlined"
            startIcon={<QrCode2Icon />}
            sx={{
              minWidth: '80px',
              px: 0.5,
              py: 0.25,
              borderRadius: 1,
              fontSize: '0.6rem',
              lineHeight: 1.2,
            }}
          >
            {t('pay')}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default QrPaymentRow;
